import {
    Box,
    Button,
    Collapse,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Config from "Config";
import moment from "moment";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { send } from "../../SendRequest";
import { getEnquiryTitleParam, isObjectNotEmpty } from "../../Utils";
import AlertDialog from "../../component/AlertDialog/AlertDialog";

const useStyles = makeStyles({
    tableRow: {
        textDecoration: "none!important",
    },
});

function HistoryTableRow({ rowData, formStatus }) {
    let item = rowData;
    const [signatureItem, setSignatureItem] = useState(null);
    const [signatureOpen, setSignatureOpen] = useState(false);
    const { t, i18n } = useTranslation();
    const classes = useStyles();
    const dispatch = useDispatch();
    const [tabOpen, setTabOpen] = React.useState(false);
    // 处理Form status展示
    function getStatusPerForm(formId, status) {
        if (formStatus != null) {
            if (
                Object.keys(formStatus).includes(formId) &&
                formStatus[formId][status] !== undefined
            ) {
                return formStatus[formId][status];
            } else {
                return formStatus["common"][status];
            }
        } else {
            return t(`common.status.${status}`);
        }
    }
    // Signature Component
    const SignatureContent = ({ srcPrefix, style }) => (
        <>
            <Typography>
                {t("common.approval.signMethod")}
                {t(`common.approval.signType.${signatureItem?.siginType}`)}
            </Typography>
            {signatureItem?.siginType == "D" && (
                <img
                    src={srcPrefix + signatureItem?.digitalSigning}
                    style={style}
                />
            )}
            {signatureItem?.siginType == "U" && (
                <img
                    src={srcPrefix + signatureItem?.digitalSigning}
                    style={style}
                />
            )}
        </>
    );

    // 下載PDF
    function getHistoryZip(formId, id) {
        let zipData = {};
        if (isObjectNotEmpty(formId) && isObjectNotEmpty(id)) {
            zipData[formId] = [id];
        }

        const option = {
            url: `${Config.CONTENT_PATH}/workflow/historyZip`,
            method: "POST",
            body: JSON.stringify(zipData),
            header: {
                Accept: "application/zip",
            },
        };
        dispatch(send("DOWNLOAD_HISTORY_ZIP", option))
            .then((res) => res.blob())
            .then((result) => {
                let aTag = document.createElement("a");
                aTag.href = URL.createObjectURL(result);
                aTag.download = `eformss_${moment().format(
                    "MM_DD_YYYY[.zip]"
                )}`;
                aTag.click();
                URL.revokeObjectURL(result);
            })
            .catch((error) => {
                console.log(error);
            });
    }

    return (
        <React.Fragment>
            {/* Form 数据 */}
            <TableRow>
                <TableCell>
                    <IconButton
                        aria-label="expand row"
                        size="small"
                        onClick={() => {
                            setTabOpen(!tabOpen);
                        }}
                    >
                        {tabOpen ? (
                            <KeyboardArrowUpIcon />
                        ) : (
                            <KeyboardArrowDownIcon />
                        )}
                    </IconButton>
                </TableCell>

                <TableCell
                    align="center"
                    component={Link}
                    to={`/approval/Form${String(item.formId).padStart(
                        3,
                        "0"
                    )}/${item.formRef}`}
                    className={classes.tableRow}
                >
                    {item.formRef}
                </TableCell>
                <TableCell
                    align="center"
                    component={Link}
                    to={`/approval/Form${String(item.formId).padStart(
                        3,
                        "0"
                    )}/${item.formRef}`}
                    className={classes.tableRow}
                >
                    {t(
                        `form.Form${String(item.formId).padStart(3, "0")}`,
                        getEnquiryTitleParam(
                            item.formId,
                            item.titleParam,
                            i18n.language
                        )
                    )}
                </TableCell>
                {/* <TableCell
                    align="center"
                    component={Link}
                    to={`/approval/Form${String(item.formId).padStart(
                        3,
                        "0"
                    )}/${item.formRef}`}
                    className={classes.tableRow}
                >
                    {getStatusPerForm(item.formId, item.statusForm)}
                </TableCell> */}
            </TableRow>

            {/* 签名历史数据 */}
            <TableRow>
                <TableCell
                    style={{
                        paddingBottom: 0,
                        paddingTop: 0,
                    }}
                    colSpan={6}
                >
                    <Collapse in={tabOpen} timeout="auto" unmountOnExit>
                        <Box
                            sx={{
                                margin: 1,
                            }}
                        >
                            <Typography
                                variant="h6"
                                gutterBottom
                                component="div"
                            >
                                {t(`common.historyEnquiry.history`)}
                            </Typography>
                            <Table size="small" aria-label="purchases">
                                <TableHead>
                                    <TableRow>
                                        <TableCell
                                            align="center"
                                            style={{ fontWeight: "bold" }}
                                        >
                                            {t(`common.date`)}
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            style={{ fontWeight: "bold" }}
                                        >
                                            {t("common.approval.signingRole")}
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            style={{ fontWeight: "bold" }}
                                        >
                                            {t(
                                                `common.historyEnquiry.operator`
                                            )}
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            style={{ fontWeight: "bold" }}
                                        >
                                            {t(
                                                `common.historyEnquiry.signatureMethod`
                                            )}
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            style={{ fontWeight: "bold" }}
                                        >
                                            {t(
                                                `common.historyEnquiry.signature`
                                            )}
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            style={{ fontWeight: "bold" }}
                                        >
                                            {t("common.portal.status")}
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            style={{ fontWeight: "bold" }}
                                        >
                                            {`${t(
                                                "common.portal.download"
                                            )} PDF`}
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {item?.historyList.length > 0 &&
                                        item.historyList.map((historyRow) => {
                                            let siginItem = {
                                                siginType:
                                                    historyRow.signatureType,
                                                digitalSigning:
                                                    historyRow.signingBytes,
                                            };
                                            return (
                                                <TableRow key={historyRow.date}>
                                                    <TableCell
                                                        component="th"
                                                        scope="row"
                                                        align="center"
                                                    >
                                                        {moment(
                                                            historyRow.createTime
                                                        ).format(
                                                            "YYYY-MM-DD  hh:mm:ss"
                                                        )}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        {
                                                            t(
                                                                `common.approval.signingRoleOption`,
                                                                {
                                                                    returnObjects: true,
                                                                }
                                                            )[
                                                                historyRow.roleType.toString()
                                                            ]
                                                        }
                                                        {/* {historyRow.roleType} */}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        {historyRow.name}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        {
                                                            t(
                                                                `common.approval.signType`,
                                                                {
                                                                    returnObjects: true,
                                                                }
                                                            )[
                                                                historyRow
                                                                    ?.signatureType
                                                            ]
                                                        }
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <Button
                                                            onClick={() => {
                                                                setSignatureItem(
                                                                    siginItem
                                                                );
                                                                setSignatureOpen(
                                                                    true
                                                                );
                                                            }}
                                                        >
                                                            {t(
                                                                "common.approval.signature.view"
                                                            )}
                                                        </Button>
                                                    </TableCell>
                                                    <TableCell
                                                        align="center"
                                                        // align="center"
                                                        // component={Link}
                                                        // to={`/approval/Form${String(
                                                        //     item.formId
                                                        // ).padStart(3, "0")}/${
                                                        //     item.formRef
                                                        // }`}
                                                        // className={
                                                        //     classes.tableRow
                                                        // }
                                                    >
                                                        {getStatusPerForm(
                                                            historyRow.formId,
                                                            historyRow.statusTo
                                                        )}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <Button
                                                            variant="contained"
                                                            color="primary"
                                                            onClick={() => {
                                                                getHistoryZip(
                                                                    historyRow.formId,
                                                                    historyRow.id
                                                                );
                                                            }}
                                                        >
                                                            {t(
                                                                "common.portal.download"
                                                            )}
                                                        </Button>
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
            <AlertDialog
                formOpen={signatureOpen}
                content={
                    <SignatureContent
                        srcPrefix="data:image;base64,"
                        style={{
                            maxHeight: "200px",
                        }}
                    />
                }
                closeButton={{
                    action: () => setSignatureOpen(false),
                    label: t("common.save.popup.cancel"),
                }}
                onClosed={() => setSignatureItem(null)}
            />
        </React.Fragment>
    );
}
export default HistoryTableRow;
